import api from './axiosInstance';

export const expenseCategoryApi = {
  list: () => api.get('/expense-categories'),
  create: (data) => api.post('/expense-categories', data),
  update: (id, data) => api.put(`/expense-categories/${id}`, data),
  remove: (id) => api.delete(`/expense-categories/${id}`),
};
